import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarData } from "src/app/common/components/snackbar/model/snackbar.model";
import { SnackBarService } from "src/app/common/components/snackbar/snackbar.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/common/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DirtyCheck } from "src/app/common/guards/form-deactivate.guard";
import { WeeklyResultByStoreReportService } from "src/app/pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service";
import { ShopinfoService } from "src/app/pages/common/system/shopinfo/shopinfo.service";
import { DepartmentService } from "src/app/pages/common/system/department/department.service";
import { FormsModule } from "@angular/forms";
import moment from "moment";
import { HourlySalesReportService } from "../hourly-sales-report/hourly-sales-report.service";
import { UserInfoModel } from "src/app/common/models/user-info.model";
import { AppConstants } from "src/app/common/app.constants";
import { MasterSalesReportCostService } from "./master-sales-report-cost.service";
import { TerminalService } from "src/app/pages/common/system/terminal/terminal.service";
import { AccessLogService } from "../access-log/access-log.service";
import { SaleItemService } from "src/app/pages/common/products/sale-item/sale-item.service";
import { ItemCategoryService } from "src/app/pages/common/products/item-category/item-category.service";
import { PermissionService } from "src/app/auth/permission.service";

@Component({
  selector: "app-master-sales-report-cost",
  standalone: false,
  templateUrl: "./master-sales-report-cost.component.html",
  styleUrl: "./master-sales-report-cost.component.scss",
})
export class MasterSalesReportCostComponent {
  user: UserInfoModel | undefined;
  title: string = "Master Sales";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  departmentListData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  shopsIsOpen = false;
  orderSourceIsOpen = false;
  terminalIsOpen = false;
  casherSourceIsOpen = false;
  itemSourceIsOpen = false;
  mainGroupSourceIsOpen = false;
  groupSourceIsOpen = false;
  permission: any;

  curFinYear!: string; // Add this to your component properties
  daysOfWeek: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  hours: string[] = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  fromHour: string = "00";
  toHour: string = "00";
  shop_id: any;
  shop_name: any;
  departmentValidationMessage: any;
  departmentSelectionInvalid: boolean = false;
  isExpandedOrder = false;
  isExpandedTerminal = false;
  isExpandedCashier = false;
  isExpandedMainGroup = false;
  isExpandedGroup = false;
  isExpandedItem = false;
  isExpandedSort = false;

  showSelectedOrderSourceOnly = false;
  showSelectedTerminalOnly = false;
  showSelectedCashierOnly = false;
  showSelectedMainGroupOnly = false;
  showSelectedGroupOnly = false;
  showSelectedItemOnly = false;

  orderSourceListData: any = [];
  terminalListData: any = [];
  usersListData: any = [];
  itemListData: any = [];
  groupListData: any = [];
  mainGroupListData: any = [];
  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private hourlySalesReportService: HourlySalesReportService,
    private masterSalesReportCostService: MasterSalesReportCostService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    public dialog: MatDialog,
    private ternimalService: TerminalService,
    private accessLogService: AccessLogService,
    private saleItemService: SaleItemService,
    private itemCategoryService: ItemCategoryService,
    private permissionService: PermissionService
  ) {
    const today = new Date();
    this.editForm = this.builder.group(
      {
        // year: this.builder.control( ''),
        period_from: this.builder.control(today, Validators.required),
        period_to: this.builder.control(today, Validators.required),
        days: this.builder.group({}),
        percentage_calculation: this.builder.control(0),

        summary_report: this.builder.control(true),
        sortBy: this.builder.control('Qty Sold'), // default value
        orderBy: this.builder.control('asc'),

        orderSourceFilter: [''],
        terminalFilter: [''],
        cashierFilter: [''],
        mainGroupFilter: [''],
        groupFilter: [''],
        itemFilter: [''],
        includeCos: this.builder.control(false)

      },
      { validators: this.hourRangeValidator() }
    );

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });
    this.permission = this.permissionService.getPagePermission("master-sales-report-cost");

    // Load saved data if it exists
    // this.loadFromSessionStorage();
    // Set all days as checked by default
    const daysGroup = this.editForm.get("days") as FormGroup;
    this.daysOfWeek.forEach((day) => {
      daysGroup.addControl(day, new FormControl(true)); // ✅ checked by default
    });
  }

  ngOnInit(): void {
    // this.loadData();
    this.shopList();
    this.OrderSourceList();
    this.TerminalList();
    this.UsersList();
    this.itemList();
    this.groupList();
    this.mainGroupList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = sesUser !== null ? JSON.parse(sesUser) : undefined;
    console.log(this.user);
  }

  selectedDays(): string[] {
    const days = this.editForm.get("days")?.value;
    return Object.keys(days).filter((day) => days[day]);
  }

  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get("fromHour")?.value;
      const to = group.get("toHour")?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }


  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find((week) => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  sortOptions = [
    { value: "shop_name", label: "Shop Name" },
    { value: "this_year_this_week_sales", label: "This Year Sales" },
    { value: "last_year_this_week_sales", label: "Last Year Sales" },
    { value: "this_week_cust_orders", label: "This Year Customer Orders" },
    { value: "last_year_cus_order", label: "Last Year Customer Orders" },
    { value: "this_week_labour_cost", label: "This Year Labour Cost" },
    {
      value: "last_year_this_week_labour_cost",
      label: "Last Year Labour Cost",
    },
  ];

  sortOrderOptions = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.departmentListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    if (shopIds.length === 0) {
      this.departmentSelectionInvalid = true;
      return;
    } else {
      this.departmentSelectionInvalid = false; // ✅ clear message when valid
    }

    // Create the data object
    const reportData = {
      year: this.editForm.get("year")?.value,
      weekNo: this.editForm.get("week_no")?.value,
      shopId: shopIds,
      sortBy: this.editForm.get("sort_by")?.value,
      sortDir: this.editForm.get("sort_order")?.value,
      isExport: 0,
    };

    // Save to sessionStorage
    sessionStorage.setItem("weeklyStoreReportData", JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem("weeklyStoreReportData");
    // console.log(savedData)
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue(
        {
          year: reportData.year,
          week_no: reportData.weekNo,
          sort_by: reportData.sortBy,
          sort_order: reportData.sortDir,
        },
        { emitEvent: false }
      ); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.departmentListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.departmentListData.forEach((shop: any) => (shop.selected = false));
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }

  onYearChange(): void {
    this.selectedYear = this.editForm.get("year")?.value;
    console.log("Selected Year:", this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(
      (fy) => fy.year === this.selectedYear
    );

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date
          } - ${week.end_date})`,
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get("week_no")?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get("week_no")?.setValue(null);
    }
  }


  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, "0");
  }

  shopList(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { offset: 0, limit: 1000000 },
        },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.departmentService.getDepartmentList(requestData).subscribe({
      next: (response: any) => {
        this.departmentListData = [];
        var index = 0;
        response.data.departments.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.departmentListData.push(data);
          index++;
        });
        console.log("data", this.departmentListData);
      },
      error: (error: any) => { }
    });
  }

  OrderSourceList(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { offset: 0, limit: 1000000 },
        },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.masterSalesReportCostService.getOrderSourceList(requestData).subscribe({
      next: (response: any) => {
        this.orderSourceListData = [];
        var index = 0;
        response.data.order_source.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.orderSourceListData.push(data);
          index++;
        });
        console.log("data", this.orderSourceListData);
      },
      error: (error: any) => { }
    });
  }

  TerminalList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.ternimalService.getTerminalList(requestData).subscribe({
      next: (response: any) => {
        this.terminalListData = [];
        var index = 0;
        response.data.terminals.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
        console.log(this.terminalListData);
      },
      error: (error: any) => { }
    });
  }

  UsersList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.accessLogService.getUsers().subscribe({
      next: (response: any) => {
        this.usersListData = [];
        var index = 0;
        response.data.users.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.usersListData.push(data);
          index++;
        });
        console.log(this.usersListData);
      },
      error: (error: any) => { }
    });
  }

  itemList(): void {
    let requestData = {
      search: {
        filters: { filter: [{ column: "is_deleted", operator: "=", value: 0 }], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "sale_item.name", order: "ASC" }],
      },
    };

    this.saleItemService.getList(requestData).subscribe({
      next: (response: any) => {
        this.itemListData = [];
        var index = 0;
        response.data.items.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.itemListData.push(data);
          index++;
        });
        console.log(this.itemListData);
      },
      error: (error: any) => { }
    });
  }

  groupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }],
      },
    };

    this.itemCategoryService.getList(requestData).subscribe({
      next: (response: any) => {
        this.groupListData = [];
        var index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id != null && item.is_super_class_id !== 0) {
            var data = { index: index, item: item, selected: false };
            this.groupListData.push(data);
            index++;
          }
        });
        console.log("data", this.groupListData);
      },
      error: (error: any) => { }
    });
  }



  mainGroupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }],
      },
    };

    this.itemCategoryService.getList(requestData).subscribe({
      next: (response: any) => {
        this.mainGroupListData = [];
        let index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id === null || item.is_super_class_id === 0) {
            let data = { index: index, item: item, selected: false };
            this.mainGroupListData.push(data);
            index++;
          }
        });
        console.log("data", this.mainGroupListData);
      },
      error: (error: any) => {
        console.error("Error fetching data:", error);
      }
    });
  }

  toggleContent(divData: string): void {
    if (divData == "expensetype") {
      this.isExpandedOrder = !this.isExpandedOrder;
    }
    if (divData == "terminaltype") {
      this.isExpandedTerminal = !this.isExpandedTerminal;
    }
    if (divData == "cashiertype") {
      this.isExpandedCashier = !this.isExpandedCashier;
    }
    if (divData == "maingrouptype") {
      this.isExpandedMainGroup = !this.isExpandedMainGroup;
    }
    if (divData == "grouptype") {
      this.isExpandedGroup = !this.isExpandedGroup;
    }
    if (divData == "itemtype") {
      this.isExpandedItem = !this.isExpandedItem;
    }
    if (divData == "itemtype") {
      this.isExpandedSort = !this.isExpandedSort;
    }
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach((el) => {
      if (el.selected) {
        count++;
      }
    });
    return sourceList.length + "/" + (count > 0 ? count : "ALL");
  }

  // --- Selection Change Handler ---
  onListSelectionChange(type: string) {
    this.saveToSessionStorage();
  }

  onShopSelectionChange(selectionData: any): void { }

  get selectedOrderSourcesCount(): number {
    return (
      this.orderSourceListData?.filter((item: any) => item.selected)?.length ||
      0
    );
  }
  get selectedTerminalSourcesCount(): number {
    return (
      this.terminalListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedCasheirSourcesCount(): number {
    return (
      this.usersListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedMainGroupSourcesCount(): number {
    return (
      this.mainGroupListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedGroupSourcesCount(): number {
    return (
      this.groupListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedItemSourcesCount(): number {
    return this.itemListData?.filter((item: any) => item.selected)?.length || 0;
  }

  navigateToWeeklyReport() {
    this.router.navigate(["/weekly-result-store-report-view"]);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }
  // --- Filtered Getters & Helper Methods ---

  // Order Source
  get filteredOrderSourceListData() {
    let filteredList = this.orderSourceListData;
    if (this.showSelectedOrderSourceOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('orderSourceFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllOrderSource() {
    const allSelected = this.orderSourceListData.every((item: any) => item.selected);
    this.orderSourceListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconOrderSource(): string {
    const allSelected = this.orderSourceListData.every((item: any) => item.selected);
    const someSelected = this.orderSourceListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // Terminal
  get filteredTerminalListData() {
    let filteredList = this.terminalListData;
    if (this.showSelectedTerminalOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('terminalFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllTerminal() {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconTerminal(): string {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    const someSelected = this.terminalListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // Cashier
  get filteredCashierListData() {
    let filteredList = this.usersListData;
    if (this.showSelectedCashierOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('cashierFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllCashier() {
    const allSelected = this.usersListData.every((item: any) => item.selected);
    this.usersListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconCashier(): string {
    const allSelected = this.usersListData.every((item: any) => item.selected);
    const someSelected = this.usersListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // Main Group
  get filteredMainGroupListData() {
    let filteredList = this.mainGroupListData;
    if (this.showSelectedMainGroupOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('mainGroupFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllMainGroup() {
    const allSelected = this.mainGroupListData.every((item: any) => item.selected);
    this.mainGroupListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconMainGroup(): string {
    const allSelected = this.mainGroupListData.every((item: any) => item.selected);
    const someSelected = this.mainGroupListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // Group
  get filteredGroupListData() {
    let filteredList = this.groupListData;
    if (this.showSelectedGroupOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('groupFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllGroup() {
    const allSelected = this.groupListData.every((item: any) => item.selected);
    this.groupListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconGroup(): string {
    const allSelected = this.groupListData.every((item: any) => item.selected);
    const someSelected = this.groupListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  // Item
  get filteredItemListData() {
    let filteredList = this.itemListData;
    if (this.showSelectedItemOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('itemFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  toggleSelectAllItem() {
    const allSelected = this.itemListData.every((item: any) => item.selected);
    this.itemListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }
  getSelectAllIconItem(): string {
    const allSelected = this.itemListData.every((item: any) => item.selected);
    const someSelected = this.itemListData.some((item: any) => item.selected);
    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }



  // exportClicked(): void {
  //   // Get selected shop IDs (if none are selected, treat it as "ALL")
  //   const selectedDepartmentIds = this.departmentListData
  //     .filter((shop: any) => shop.selected)
  //     .map((shop: any) => shop.item.id);

  //   // Check: At least one department selected
  //   // if (selectedDepartmentIds.length === 0) {
  //   //   this.departmentSelectionInvalid = true;
  //   //   this.departmentValidationMessage='Please select at least one department.';
  //   //   return;
  //   // } else {
  //   //   this.departmentSelectionInvalid = false; // ✅ clear message when valid
  //   // }
  //   // If no shops are selected, we treat it as "ALL" (empty array means all shops)
  //   const shopIds =
  //     selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
  //   var rawDateFrom = this.editForm.get("period_from")?.value;
  //   var formattedDateFrom = moment(rawDateFrom).format("DD-MM-YYYY");
  //   var rawDateTo = this.editForm.get("period_to")?.value;
  //   var formattedDateTo = moment(rawDateTo).format("DD-MM-YYYY");
  //   var days = this.selectedDays();
  //   // Create the data object
  //   if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
  //     this.shop_id = this.user?.shop_info.id;
  //     this.shop_name = this.user?.shop_info.name;
  //   }
  //   const reportData = {
  //     shopId: this.shop_id,
  //     shopName: this.shop_name,
  //     dateFrom: formattedDateFrom,
  //     dateTo: formattedDateTo,
  //     departmentId: shopIds,
  //     days: days,
  //     prcCal: this.editForm.get("percentage_calculation")?.value,
  //     hourFrom: this.editForm.get("fromHour")?.value,
  //     hourTo: this.editForm.get("toHour")?.value,
  //     summaryReport: this.editForm.get("summary_report")?.value,
  //     isExport: 1,
  //   };
  //   if (reportData) {
  //     this.hourlySalesReportService
  //       .exportHourlySalesReport(reportData)
  //       .subscribe({
  //         next: (response) => {
  //           // Create a download link for the Excel file
  //           const blob = new Blob([response], {
  //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //           });
  //           const url = window.URL.createObjectURL(blob);
  //           const a = document.createElement("a");
  //           a.href = url;
  //           a.download = "hourly-sales-report.xlsx";
  //           document.body.appendChild(a);
  //           a.click();
  //           document.body.removeChild(a);
  //           window.URL.revokeObjectURL(url);
  //         },
  //         error: (error) => {
  //           console.error("Error fetching data:", error);
  //         },
  //       });
  //   }
  // }


  exportClicked(): void {
    const from = this.editForm.get("period_from")?.value;
    const to = this.editForm.get("period_to")?.value;
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24);
      if (diff >= 365) {
        this.snackBarService.openSnackBar({
          message: "Please choose a date range shorter than 365 days.",
          type: "warn"
        } as SnackBarData);
        return;
      }
    }

    if (this.editForm.valid) {
      // Get selected shop IDs (if none are selected, treat it as "ALL")
      const selectedDepartmentIds = this.departmentListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedOrerSourcesIds = this.orderSourceListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.key);
      const selectedTerminalIds = this.terminalListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedCashierIds = this.usersListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedMainGroupIds = this.mainGroupListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedGroupIds = this.groupListData.filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selecteditemIds = this.itemListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      // Check: At least one department selected
      // if (selectedDepartmentIds.length === 0) {
      //   this.departmentSelectionInvalid = true;
      //   this.departmentValidationMessage='Please select at least one department.';
      //   return;
      // } else {
      //   this.departmentSelectionInvalid = false; // ✅ clear message when valid
      // }
      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const shopIds =
        selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
      const orderIds = selectedOrerSourcesIds.length > 0 ? selectedOrerSourcesIds : [];
      const terminalIds = selectedTerminalIds.length > 0 ? selectedTerminalIds : [];
      const casherlIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
      const mainGroupIds = selectedMainGroupIds.length > 0 ? selectedMainGroupIds : [];
      const GroupIds = selectedGroupIds.length > 0 ? selectedGroupIds : [];


      var rawDateFrom = this.editForm.get("period_from")?.value;
      var formattedDateFrom = moment(rawDateFrom).format("DD-MM-YYYY");
      var rawDateTo = this.editForm.get("period_to")?.value;
      var formattedDateTo = moment(rawDateTo).format("DD-MM-YYYY");
      var days = this.selectedDays();
      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        dateFrom: formattedDateFrom,
        dateTo: formattedDateTo,
        Shift: "DailyShift",
        orderSource: orderIds,
        terminalId: terminalIds,
        cashierFrom: casherlIds,
        mainGroupFrom: mainGroupIds,
        groupFrom: GroupIds,
        itemFrom: selecteditemIds,
        sortBy: this.editForm.get("sortBy")?.value,
        orderBy: this.editForm.get("orderBy")?.value,
        includeCost: this.editForm.get("includeCos")?.value ? 1 : 0,
        shopName: this.shop_name,



      };
      this.IsDownloading = true;
      if (reportData) {
        this.masterSalesReportCostService
          .exportMasterSalesReport(reportData)
          .subscribe({
            next: (response) => {
              // Handle "No data found" response
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const text = reader.result as string;
                  const json = JSON.parse(text);
                  if (json.status === 'NO_DATA_FOUND') {
                    let snackBarData: SnackBarData = {
                      message: 'No data found.',
                      title: 'No Data!!!',
                      type: 'warn'
                    }
                    this.IsDownloading = false;
                    this.snackBarService.openSnackBar(snackBarData);
                    return;
                  }
                } catch (e) {
                  // Not JSON, treat as file
                  const blob = new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "master-sales-report.xls";
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
                  this.IsDownloading = false;
                  return;
                }
                // If JSON but not NO_DATA_FOUND, treat as error
                this.IsDownloading = false;
              };
              reader.readAsText(response);
            },
            error: (error) => {
              this.IsDownloading = false;
              let snackBarData: SnackBarData = {
                message: 'Failed to update. Connection to the server failed',
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            },
          });
      }
    } else {
      this.editForm.markAllAsTouched();

    }
  }
}
